// Lightweight web implementation avoiding native Keychain/MMKV

export class SecureStorage {
  private static instance: SecureStorage;

  static getInstance(): SecureStorage {
    if (!SecureStorage.instance) {
      SecureStorage.instance = new SecureStorage();
    }
    return SecureStorage.instance;
  }

  async saveToken(token: string): Promise<void> {
    if (!token?.trim()) throw new Error('Invalid token provided');
    localStorage.setItem('resio_access_token', token);
  }

  async getToken(): Promise<string | null> {
    return localStorage.getItem('resio_access_token');
  }

  async saveRefreshToken(_: string): Promise<void> {
    // Refresh token is httpOnly cookie on web; ignore
    return;
  }

  async getRefreshToken(): Promise<string | null> {
    // Not accessible on web (httpOnly)
    return null;
  }

  async clearTokens(): Promise<void> {
    localStorage.removeItem('resio_access_token');
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(`resio_${key}`, JSON.stringify(value));
  }

  getItem<T>(key: string): T | null {
    const value = localStorage.getItem(`resio_${key}`);
    if (!value) return null;
    try { return JSON.parse(value) as T; } catch { return null; }
  }

  removeItem(key: string): void {
    localStorage.removeItem(`resio_${key}`);
  }

  clearAll(): void {
    // Only clear namespaced keys
    Object.keys(localStorage)
      .filter((k) => k.startsWith('resio_') || k === 'resio_access_token')
      .forEach((k) => localStorage.removeItem(k));
  }

  async isBiometricAvailable(): Promise<boolean> { return false; }
}

export default SecureStorage;


